<template>
  <div class="replacement-week-view">
    <div class="container is-max-desktop">
      <div class="has-text-centered calendar-header">
        Afløserkalender
      </div>
      <div class="scroll-view">
        <calendar-entry v-for="(entry, index) in replacementAllocations"
                        :key="index"
                        :entry="entry"
                        :allocationTypes="allocationTypes"
                        :circles-lookup="circles"
                        @click.native="openSidebar(entry)">
        </calendar-entry>
      </div>
    </div>
  </div>
</template>

<script>
import ApiState from '../enums/APISTATE';
import { mapActions, mapGetters } from 'vuex';
import CalendarEntry from '../components/calendar/calendar-small/CalendarEntry.vue';

export default {
  name: "replacement-week-view",
  components: { CalendarEntry },
  async mounted() {
    await Promise.all([
      this.$store.dispatch('metadata/initialize'),
      this.loadEmployees(),
      this.loadCirclesCurrentWeek()
    ]);
    await this.loadReplacementAllocationsForCurrentWeek();
  },
  computed: {
    ...mapGetters('replacementAllocations', [
      'replacementAllocationsApiState',
      'replacementAllocations'
    ]),
    ...mapGetters('metadata', [
      'allocationTypes'
    ]),
    ...mapGetters('circles', [
      'circles'
    ])
  },
  methods: {
    ...mapActions('replacementAllocations', [
      'loadReplacementAllocationsForCurrentWeek'
    ]),
    ...mapActions('entrySidebar', [
      'entrySidebarOpenAsync'
    ]),
    ...mapActions('circles', [
      'loadCirclesCurrentWeek'
    ]),
    ...mapActions("employees", ["loadEmployees"]),
    openSidebar(entry) {
      entry.canEdit = true;

      this.entrySidebarOpenAsync(entry).then((response) => {
      }).catch((error) => console.error(error));
    }
  }
}
</script>

<style lang="scss">
.replacement-week-view {
  .calendar-header {
    font-size: 24px;
    font-weight: 700;
    padding-top: 20px;
    padding-bottom: 10px;
  }
  .scroll-view {
    padding: 10px;
  }
}
</style>
